import React from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import { Icon } from 'react-fa';
import EditableDropdown from './EditableDropdown';
import EditNotice from './EditNotice';
import Dialog from 'rc-dialog';
import Table from 'rc-table';
import 'rc-dialog/assets/bootstrap.css';
import 'rc-dropdown/assets/index.css';
import ActiveRow from '../ActiveRow'
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import VinculacionCuentas from './VinculacionCuentas';
import { GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

//Mensaje de exíto que se muestra cuando la baja fue realizada correctamente...
const Alerta = (props) => {
    if (props.mostrarError == true) {
        return <div className="ancho-mensaje-alerta"> <GenericAlert message="La operación fue realizada correctamente." type="success" /> </div>;
    } else {
        return null;
    }
}

let _event;
let _funcionEjecutarCambio;

const DetalleTarjetaHeading = ({ tarjetaActual, cuenta }) => {

    return (
        <div className="DetalleHeading table-detalle-apoderado">
            <span>{cuenta.cuentas} {cuenta.numero}</span>
            <i className="glyphicon glyphicon-menu-right"></i>
            <span>{tarjetaActual.tarjeta}</span>
            <i className="glyphicon glyphicon-menu-right"></i>
            <span>Tarjetas</span>
            <span className="IconContainerTarjetas">
                <span className="Icon-PDF">
                    <Icon name="file-pdf-o" size="lg" />
                </span>  |
                <span className="Icon-File">
                    <Icon name="print" size="lg" />
                </span>
            </span>
            <hr />
        </div>
    );

}

function getFechaFormateada(fecha) {
    fecha = new Date(fecha);
    let fechaFormated = fecha.getDate() + "/"
        + (fecha.getMonth() + 1) + "/"
        + (fecha.getFullYear()) + " a las "
        + (fecha.getHours()) + ":"
        + (fecha.getMinutes().toString().length == 1 ? '0' + fecha.getMinutes().toString() : fecha.getMinutes().toString());

    return fechaFormated;
}

function getCurrentDateAsString() {

    const today = new Date();
    const dd = (today.getDate() < 10 ? "0" : "") + today.getDate();
    const mm = ((today.getMonth() + 1) < 10 ? "0" : "") + (today.getMonth() + 1);  //January is 0!
    const yyyy = today.getFullYear();
    const hour = (today.getHours() < 10 ? "0" : "") + today.getHours();
    const min = (today.getMinutes() < 10 ? "0" : "") + today.getMinutes();

    const date = dd + "-" + mm + '-' + yyyy;
    const time = hour + ":" + min;
    const now = date + ", " + time;

    return now;
}

const DropdownReimpresion = ({ disabled, menu }) => {

    const dropdownClass = "btn btn-default" + (disabled ? " disabled" : " ");

    if (disabled)
        return (
            <button className={dropdownClass} type="button">
                Reimprimir &nbsp;
          <span className="caret"></span>
            </button>
        );

    return (
        <Dropdown
            trigger={['click']}
            overlay={menu}
            animation="slide-up"
        >
            <button className={dropdownClass} type="button">
                Reimprimir &nbsp;
         <span className="caret"></span>
            </button>
        </Dropdown>
    );
}

class DetalleApoderadoTarjeta extends React.Component {

    constructor(props) {

        super(props)

        this.state = {
            tarjetaDialogVisible: false,
            historyDialogVisible: false,
            deleteDialogVisible: false,
            pinDialogVisible: false,
            domicilioEdit: null,
            limiteEdit: null,
            tipoBorrado: "",
            estadoReimpresion: false
        };

        const { tarjetaActual } = this.props;
        this.props.mostrarAlertaProcesoFinalizado(false);
    }

    domicilioEdited(value) {
        if (value !== -1) {
            let domicilio = this.props.plasticos.domicilios.find(x => x.LOCALIDAD == value);

            let valorModificacion = {
                type: 'DOMICILIO',
                value: domicilio,
                login: this.props.UserId
            }
            this.setState({ CambioDomicilioLimiteVisible: false });
            this.props.modificarSolicitud(valorModificacion, this.props.plasticos, this.props.tarjetaActual, this.props.tarjetaActual.cuentaNro);
        }
    }

    limiteEdited(value) {
        if (value > 0) {
            let valorModificacion = { type: 'LIMITE', value: value }
            this.setState({ CambioDomicilioLimiteVisible: false });
            this.props.modificarSolicitud(valorModificacion, this.props.plasticos, this.props.tarjetaActual, this.props.tarjetaActual.cuentaNro);
        }
    }

    openModal() {
        this.props.GetVinculosByNroTarjeta(this.props.tarjetaActual.numero);
        this.props.mostrarOcultarModalVinculos(true);
    }

    onClose() {
        this.setState({ visible: false });
    }

    toggleHistoryModal() {
        this.setState({ historyDialogVisible: true });
        this.props.getHistorialMovimiento(this.props.tarjetaActual.numero);
    }

    toggleDeleteModal() {
        this.setState({ deleteDialogVisible: true });
    }

    toggleModal(key) {

        const modalTarjeta = parseInt(key.key, 10) === 1 ? true : false;

        if (modalTarjeta) {
            this.setState({ tarjetaDialogVisible: true });
        }
        else {
            let row = this.props.tarjetaActual;
            let solicitud = this.props.plasticos.solicitudes.find(x => parseInt(x.Col64) == parseInt(row.numero) && (x.Col1 == "210001" || x.Col1 == "210002" || x.Col1 == "170000" || x.Col1 == "190000"));

            if (solicitud !== undefined && (solicitud.Col1 == "170000") && (solicitud.Estado.toLowerCase() == 'p' || solicitud.Estado.toLowerCase() == 't')) {
                this.setState({ estadoReimpresion: true })
            } else {
                this.setState({ pinDialogVisible: true });
            }
        }
    }

    toggleModalReimprimirPinVisible(estado) {
        this.setState({ estadoReimpresion: estado })
    }

    changeTipoBorrado(tipo) {
        this.setState({ tipoBorrado: tipo });
    }

    closeDomicilioLimiteDialog() {
        this.setState({ CambioDomicilioLimiteVisible: false });
    }

    openCloseVinculacionOkCancelDialog(visible) {
        this.setState({ ConfirmarVinculacionVisible: visible });
    }

    confirmarVinculacion(cuentasVinculadas, numero, cuentaPrincipal, plasticos) {
        this.setState({ ConfirmarVinculacionVisible: false });
        this.props.grabarVinculacion(cuentasVinculadas, numero, cuentaPrincipal, plasticos)
    }

    openDomicilioLimiteDialog(event, tipo) {
        _event = event.target.value;
        if (tipo == 'LIMITE') {
            _funcionEjecutarCambio = (value) => this.limiteEdited(value);
        } else {
            _funcionEjecutarCambio = (value) => this.domicilioEdited(value);
        }

        this.setState({ CambioDomicilioLimiteVisible: true });
    }

    closeDeleteDialog() {
        this.setState({ deleteDialogVisible: false });
    }

    closeTarjetaDialog() {
        this.setState({ tarjetaDialogVisible: false });
    }

    closePinDialog() {
        this.setState({ pinDialogVisible: false });
    }

    closeHistoryDialog() {
        this.setState({ historyDialogVisible: false });
    }

    componentDidMount() {
        this.props.getSolicitudesTarjetaByTarjetaId(this.props.tarjetaActual.id_plastico);
    }

    borrarTarjetas(plasticos, tarjetaActual, tipoBorrado, cuentaNro, tipoVinculo) {
        this.setState({ deleteDialogVisible: false });

        if (tipoVinculo != 1)
            this.props.borrarTarjeta(plasticos, tarjetaActual, "UNICO", cuentaNro);
        else
            this.props.borrarTarjeta(plasticos, tarjetaActual, tipoBorrado, cuentaNro);
    }

    reimprimirPin(tarjetaActual, plasticos, cuentaNro) {
        this.setState({ pinDialogVisible: false });
        this.props.reimprimirPin(tarjetaActual, plasticos, cuentaNro);
    }

    reimprimirTarjeta(tarjetaActual, plasticos, cuentaNro) {
        this.setState({ tarjetaDialogVisible: false });
        this.props.reimprimirTarjeta(tarjetaActual, plasticos, cuentaNro);
    }

    render() {

        let tarjeta = this.props.plasticos.tarjetas.find(x => x.Numero == this.props.tarjetaActual.numero);
        let solicitudes = this.props.plasticos.solicitudes;

        let soloLectur = false;
        for (var i = 0; i < solicitudes.length; i++) {
            if (solicitudes[i].NumeroCuenta == tarjeta.NumeroCuenta && (solicitudes[i].TdTransaccionLinkId == 210001 || solicitudes[i].TdTransaccionLinkId == 210002))
                soloLectur = true;
        }

        const { tarjetaActual, cuenta } = this.props;

        const menu = (
            <Menu className="ddl-reimprimir" onSelect={this.toggleModal.bind(this)} selectedKeys={[]}>
                <MenuItem key={1}>
                    <div className="div-image-label-select-menu2">
                        <span className="ti-credit-card" aria-hidden="true"></span>
                    </div>
                    <label className="label-secondary label-select-menu">Tarjeta</label>
                </MenuItem>
                <MenuItem key={2}>
                    <div className="div-image-label-select-menu2">
                        <span className="ti-more-alt" aria-hidden="true"></span>
                        <label className="label-secondary label-select-menu">Pin</label>
                    </div>
                </MenuItem>
            </Menu>
        );

        //Columnas de la tablas de tarjetas...
        this.columns = [
            {
                title: 'TIPO',
                dataIndex: 'tipo',
                key: 'tipo'
            },
            {
                title: ' ',
                dataIndex: 'numero',
                key: 'numero'
            },
            {
                title: 'VINCULO',
                dataIndex: 'vinculo',
                key: 'vinculo'
            },
            {
                title: 'SUCURSAL',
                dataIndex: 'sucursal',
                key: 'sucursal'
            }
        ];

        let cuentasContieneTarjeta = [];
        for (var m = 0; m < this.props.plasticos.tarjetas.length; m++) {
            if (this.props.plasticos.tarjetas[m].TdPlasticoId == this.props.tarjetaActual.id_plastico) {
                let c = this.props.plasticos.cuentasDelivery.find(x => x.CodigoCuenta == this.props.plasticos.tarjetas[m].NumeroCuenta);
                if (c !== undefined) {
                    cuentasContieneTarjeta.push({
                        tipo: c.NombreProducto,
                        numero: 'Nº' + c.CodigoCuenta,
                        vinculo: c.NombreVinculo,
                        sucursal: c.Sucursal,
                    })
                }
            }
        }

        let historialMovimientosDiv = undefined;
        let fechaAnterior = "";
        if (this.props.data.historialTarjetas !== undefined) {
            historialMovimientosDiv = this.props.data.historialTarjetas.map((movimientos) => {
                let componente = null;
                let texto = "";

                if (movimientos.Tipo == 'delivery') {
                    texto = <p>Estado {movimientos.Descripcion} modificado por {movimientos.Login}.</p>
                } else {
                    texto = <p>Solicitud creada por {movimientos.Login} del tipo {movimientos.Descripcion}</p>
                }

                if (movimientos.Fecha == fechaAnterior) {
                    componente = <div>
                        {texto}
                    </div>;
                } else {
                    <hr />
                    componente = <div><div className="div-historial-movimiento"><p><b>{movimientos.Fecha}</b></p></div>
                        {texto}
                    </div>;
                }

                fechaAnterior = movimientos.Fecha
                return (componente);
            })
        }

        //Permite motrar u ocultar los links de editado...
        let editadoDomicilio = null;
        let editadoLimite = null;
        let solicitudPlastico = undefined;

        if (this.props.plasticos.plasticosSolicitudes !== undefined && this.props.plasticos.plasticosSolicitudes.length > 0)
            solicitudPlastico = this.props.plasticos.plasticosSolicitudes.find(x => x.TdPlasticoId = this.props.tarjetaActual.id_plastico);

        if (solicitudPlastico !== undefined) {
            let plastico = this.props.plasticos.tarjetas.find(x => x.id_plastico == solicitudPlastico.TdPlasticoId)
            let login = solicitudPlastico.Login == null ? "" : ' por: ' + solicitudPlastico.Login;
            let solicitud = this.props.plasticos.solicitudes.find(x => x.Id == solicitudPlastico.TdSolicitudId);

            let editTextDomicilio = getFechaFormateada(solicitud.Fecha) + login + ". Era: " + plastico.DomicilioPlastico;
            let editTextLimite = getFechaFormateada(solicitud.Fecha) + login + ". Era: " + plastico.LimiteDescripcion;

            editadoDomicilio = solicitudPlastico.Domicilio !== null ? <EditNotice value={editTextDomicilio} /> : null;
            editadoLimite = solicitudPlastico.CodigoLimiteId !== null ? <EditNotice value={editTextLimite} /> : null;

        }

        //Cargo combos domicilio y limites...
        let domicilioResult;
        if (this.props.plasticos.domicilios !== undefined) {
            domicilioResult = this.props.plasticos.domicilios.map((domicilio) => {
                if (domicilio.LOCALIDAD != -1) {
                    return (
                        <GenericOption key={domicilio.LOCALIDAD} id={domicilio.LOCALIDAD}
                            description={domicilio.CALLE + " " + domicilio.NUMERO_CALLE + ", " + domicilio.DESC_PROVINCIA + ", " + domicilio.CODIGO_POSTAL + " (" + domicilio.DESC_TIPO_DOMIC + ")"} />
                    )
                } else {
                    return (
                        <GenericOption key={domicilio.LOCALIDAD} id={domicilio.LOCALIDAD}
                            description={"Seleccione..."} />
                    )
                }
            })
        }


        let limitesResult;
        if (this.props.plasticos.limites !== undefined) {
            limitesResult = this.props.plasticos.limites.map((limite) => {
                return (<GenericOption id={limite.CodigoInterno} description={limite.Sintetico === undefined ? limite.LimiteDescripcion : limite.Sintetico + " - " + limite.LimiteDescripcion} key={"LimOp_" + limite.CodigoInterno} />)
            })
        }

        let fechaVigencia;
        let fechaVigenciaFormateada;
        if (tarjeta.FechaVigenciaHasta !== undefined && tarjeta.FechaVigenciaHasta !== null) {
            fechaVigencia = new Date(tarjeta.FechaVigenciaHasta);
            fechaVigenciaFormateada = tarjeta.FechaVigenciaHasta.substr(8, 2) + '/' + tarjeta.FechaVigenciaHasta.substr(5, 2) + '/' + tarjeta.FechaVigenciaHasta.substr(0, 4);
        } else {
            fechaVigenciaFormateada = "Sin información";
        }

        let domicilioSeleccionadoFind;
        let limiteSeleccionadoFind;

        if (this.props.plasticos !== undefined && this.props.plasticos.domicilios !== undefined)
            domicilioSeleccionadoFind = this.props.plasticos.clienteResultadoBusqueda.Domicilios[0];

        const domicilioSeleccionado = domicilioSeleccionadoFind !== undefined ? domicilioSeleccionadoFind.Direccion.Localidad.toString() : "-1";

        if (this.props.plasticos.limites !== undefined && solicitudPlastico !== undefined)
            limiteSeleccionadoFind = this.props.plasticos.limites.find(x => x.CodigoInterno == solicitudPlastico.CodigoLimiteId);
        else
            limiteSeleccionadoFind = this.props.plasticos.limites.find(x => x.CodigoInterno == this.props.tarjetaActual.limite_codigo);

        const limiteSeleccionado = limiteSeleccionadoFind !== undefined ? limiteSeleccionadoFind.CodigoInterno : "0";

        var c = this.props.plasticos.cuentasDelivery.find(x => x.CodigoCuenta == this.props.tarjetaActual.cuentaNro);
        let cuentaEstado = this.props.plasticos.consultaCuenta.find(x => x.Cuenta == this.props.tarjetaActual.cuentaNro && x.Sucursal == c.Sucursal);

        let TituloBaja = tarjetaActual.vinculoTarjeta == 1 ? "Baja de tarjeta para titular" : "Baja de tarjeta";
        let texto2Reimpresion = 'De este pl' + String.fromCharCode(225) + 'stico el PIN est' + String.fromCharCode(225) + ' siendo reimpreso. Intente m' + String.fromCharCode(225) + 's tarde.';
        return (
            <div>
                <DetalleTarjetaHeading
                    tarjetaActual={tarjetaActual}
                    cuenta={cuenta}
                />

                <Alerta mostrarError={this.props.data.procesoExitoso} />

                <div>
                    <h2>{tarjeta.Nombre}</h2>
                </div>

                <div className="div-datos-generales-header">

                    {soloLectur ? null : <DropdownReimpresion disabled={false} menu={menu} />}

                    {soloLectur ? null : <button className="btn btn-default IconHistory" onClick={() => this.toggleHistoryModal()}>
                        <Icon name="history" size="lg" />
                    </button>}


                    {soloLectur ? null : <button className="btn btn-default IconTrash" onClick={() => this.toggleDeleteModal()} disabled={false/*this.props.state.existeSolicitud*/}>
                        <Icon name="trash" size="lg" />
                    </button>}

                    <ActiveRow newCard={false} estado={tarjeta.Activo} isChildRow={true} />

                </div>

                <br />
                <br />

                <div>
                    <p>Tipo de tarjeta</p>
                    <p>
                        <em>{tarjeta.DescripcionTarjeta}</em>
                        <br />
                        <strong><em>{'Nº' + tarjeta.Numero}</em></strong>
                    </p>
                </div>

                <br />

                <div>
                    <p>Vínculo</p>
                    <p>
                        {this.props.tarjetaActual.vinculoTarjeta == 1 ? "Titular" : "Adicional"}
                    </p>
                </div>

                <br />

                <div className="div-combos">
                    <p>Domicilio</p>
                    <p>
                        {this.props.plasticos.domicilios[1].CALLE + " " + this.props.plasticos.domicilios[1].NUMERO_CALLE + ", " + this.props.plasticos.domicilios[1].DESC_PROVINCIA + ", " + this.props.plasticos.domicilios[1].CODIGO_POSTAL + " (" + this.props.plasticos.domicilios[1].DESC_TIPO_DOMIC + ")"}
                    </p>

                    {/* ´POR EL MOMENTO QUEDARA COMENTADO...     
                        <GenericSelect
                        id="selectDomicilioSeleccionarCuenta"
                        className="form-control default-select"
                        options={domicilioResult}
                        onChange={(e) => this.openDomicilioLimiteDialog(e, 'DOMICILIO')}
                        value={domicilioSeleccionado}
                    /> */}
                    {editadoDomicilio}
                </div>

                <br />

                <div className="div-combos">
                    <p>Límite</p>
                    <GenericSelect
                        id="selectLimiteSeleccionarCuenta"
                        className="form-control default-select"
                        options={limitesResult}
                        value={limiteSeleccionado}
                        onChange={(e) => this.openDomicilioLimiteDialog(e, 'LIMITE')}
                    />
                    {editadoLimite}
                </div>

                <br />

                <div>
                    <p>Fecha de vencimiento</p>
                    <p>
                        {fechaVigenciaFormateada}
                    </p>
                </div>

                <br />

                <div>
                    <h3>Cuentas asignadas a la tarjeta</h3>
                    <Table
                        columns={this.columns}
                        data={cuentasContieneTarjeta}
                        emptyText="No existen cuentas asignadas a la tarjeta."
                        className="table-detalle-apoderado"
                    />
                </div>

                <div className="btn-asignar-cuenta-margen">
                    <button type="button" className="btn btn-link" onClick={() => this.openModal()} >
                        Asignar nueva cuenta
                    </button>
                </div>

                <div>
                    <Dialog
                        visible={this.state.tarjetaDialogVisible}
                        onClose={this.closeTarjetaDialog.bind(this)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 600 }}
                        title="Reimpresión de tarjeta"
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="close"
                                    onClick={() => this.reimprimirTarjeta(this.props.tarjetaActual, this.props.plasticos, this.props.tarjetaActual.cuentaNro)}
                                >
                                    Reimprimir tarjeta
                           </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={this.closeTarjetaDialog.bind(this)}
                                >
                                    Cancelar
                           </button>
                            ]
                        }
                    >
                        <p>
                            Al reimprimir la tarjeta de nombre del titular será dada de baja la tarjeta anterior de
                            forma automática una vez que link la haya confirmado.
                        </p>
                    </Dialog>
                </div>

                <div>
                    <Dialog
                        visible={this.state.pinDialogVisible}
                        onClose={this.closePinDialog.bind(this)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 600 }}
                        title="Reimpresión de pin"
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="close"
                                    onClick={() => this.reimprimirPin(this.props.tarjetaActual, this.props.plasticos, this.props.tarjetaActual.cuentaNro)}
                                >
                                    Reimprimir pin
                         </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={this.closePinDialog.bind(this)}
                                >
                                    Cancelar
                         </button>
                            ]
                        }
                    >
                        <p>
                            Al reimprimir el pin de nombre del titular será dado de baja el pin anterior de forma automática una vez que link lo haya confirmado.
                        </p>
                    </Dialog>
                </div>
                <div>
                    <Dialog
                        visible={this.state.estadoReimpresion}
                        onClose={() => this.toggleModalReimprimirPinVisible(false)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 600 }}
                        title={"Atenci" + String.fromCharCode(243) + "n"}
                        footer={[<button type="button" className="btn btn-default" key="close" onClick={() => this.toggleModalReimprimirPinVisible(false)}>
                            Cerrar
                            </button>
                        ]}>
                        <p>{texto2Reimpresion}</p>
                    </Dialog>
                </div>
                <div>
                    {/*Modal Vinculacion...*/}
                    <Dialog
                        visible={this.props.data.mostrarVinculos}
                        onClose={() => this.props.mostrarOcultarModalVinculos(false)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 778 }}
                        title={"Cuenta N°" + this.props.tarjetaActual.cuentaNro}
                        afterClose={() => this.props.getVinculaciones(this.props.tarjetaActual, this.props.plasticos.cuentasDelivery, this.props.plasticos.tarjetas)}
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="account"
                                    onClick={() => this.openCloseVinculacionOkCancelDialog(true)}
                                >
                                    Actualizar
                        </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="close"
                                    onClick={() => this.props.mostrarOcultarModalVinculos(false)}
                                >
                                    Cancelar
                        </button>
                            ]
                        }
                    >
                        <VinculacionCuentas data={this.props.data} plasticos={this.props.plasticos} tarjetaActual={this.props.tarjetaActual} agregarQuitarCuentaVinculo={this.props.agregarQuitarCuentaVinculo} cambiarCuentaPrincipal={this.props.cambiarCuentaPrincipal}
                            mostrarVinculos={this.props.mostrarVinculos}
                            getVinculaciones={this.props.getVinculaciones} borrarVinculo={this.props.borrarVinculo} />
                    </Dialog>
                </div>

                <div>
                    <Dialog
                        visible={this.state.ConfirmarVinculacionVisible}
                        onClose={() => this.openCloseVinculacionOkCancelDialog(false)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 600 }}
                        title="Generar solicitud"
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="close"
                                    onClick={() => this.confirmarVinculacion(this.props.data.cuentasVinculadas, this.props.tarjetaActual.numero,
                                        this.props.data.cuentaPrincipal, this.props.plasticos)}
                                >
                                    Continuar
                           </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={() => this.openCloseVinculacionOkCancelDialog(false)}
                                >
                                    Cancelar
                           </button>
                            ]
                        }
                    >
                        <p>Se actualizaran las vinculaciones entre cuentas. ¿Desea continuar?</p>
                    </Dialog>
                </div>
                {/*Fin modal Vinculacion...*/}

                <div>
                    <Dialog
                        visible={this.state.historyDialogVisible}
                        onClose={this.closeHistoryDialog.bind(this)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 500 }}
                        title="Historial"
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={this.closeHistoryDialog.bind(this)}
                                >
                                    Cerrar
                         </button>
                            ]
                        }
                    >
                        {historialMovimientosDiv}
                    </Dialog>
                </div>

                <div>
                    <Dialog
                        visible={this.state.deleteDialogVisible}
                        onClose={this.closeDeleteDialog.bind(this)}
                        animation="slide-fade"
                        maskAnimation="fade"
                        style={{ width: 700 }}
                        title={TituloBaja}
                        footer={
                            [
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="cancel"
                                    onClick={() => this.borrarTarjetas(this.props.plasticos, this.props.tarjetaActual, this.state.tipoBorrado, this.props.tarjetaActual.cuentaNro, tarjetaActual.vinculoTarjeta )}
                                >
                                    Aceptar
                       </button>,
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    key="delete"
                                    onClick={this.closeDeleteDialog.bind(this)}
                                >
                                    Cancelar
                       </button>
                            ]
                        }
                    >
                        {tarjetaActual.vinculoTarjeta == 1 ?
                            <form action="">
                                <input type="radio" name="baja" value="titular" className="RadioInput" onClick={() => this.changeTipoBorrado("UNICO")} /> &nbsp; Dar de baja únicamente la tarjeta del titular.<br />
                                <input type="radio" name="baja" value="adicionales" className="RadioInput" onClick={() => this.changeTipoBorrado("MULTIPLE")} /> &nbsp;  Dar de baja la tarjeta del titular y sus adicionales.<br /></form>: <label>Se dara de baja el plastico actual.</label>}
                        

                            <br />

                    </Dialog>
                </div>

                    <div>
                        <Dialog
                            visible={this.state.CambioDomicilioLimiteVisible}
                            onClose={this.closeDomicilioLimiteDialog.bind(this)}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title="Generar solicitud"
                            footer={
                                [
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        key="close"
                                        onClick={() => _funcionEjecutarCambio(_event)}
                                    >
                                        Continuar
                           </button>,
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        key="cancel"
                                        onClick={this.closeDomicilioLimiteDialog.bind(this)}
                                    >
                                        Cancelar
                           </button>
                                ]
                            }
                        >
                            <p>Este cambio generará una solicitud a link.¿ Desea continuar?</p>
                        </Dialog>
                    </div>
                </div >
                );

    }
}

export default DetalleApoderadoTarjeta;
